import React from 'react';

export const ProgressBar = React.memo(({ currentStep, totalSteps }) => {
  const progressPercentage = (currentStep / totalSteps) * 100;
  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        marginBottom: '20px',
      }}
    >
      <div
        style={{
          width: '50%',
          backgroundColor: '#e0e0e0',
          borderRadius: '5px',
          height: '10px',
        }}
      >
        <div
          style={{
            width: `${progressPercentage}%`,
            backgroundColor: '#ff9800',
            height: '100%',
            borderRadius: '5px',
            transition: 'width 0.3s ease',
          }}
        />
      </div>
    </div>
  );
});

ProgressBar.displayName = 'ProgressBar';
